import themeBase from './smpl';

import chroma from 'chroma-js';

import heatMapTheme from './heatMapTheme';

export const getColour = (number = 6, themeType) => {


  const theme  = themeType === 'heatmap' ? heatMapTheme.colors : themeBase.colors;

  if (number <= theme.length) {
    return theme;
  } else {
    const remaining = number - theme.length;
    let extended = [];

    const remainingRound = remaining / theme.length + 1;


    for (let i = 0; i < remainingRound; i++) {
      for (const b of theme) {
        const basecolour = b + '';

        const percentage = 1 - 0.20*(i+1);
        console.log(percentage);
        const extend = chroma(basecolour).alpha(percentage).css();


        extended.push(extend);
      }
    }

    return [...theme, ...extended];



    // for (let i = 0; i < (; i++) {
    //   for (const b of theme) {
    //
    //     const basecolour = b + '';
    //
    //     const percentage = 1 - Math.pow(0.5, i+1);
    //
    //
    //     let extend;
    //
    //     extend = chroma(basecolour).lighten(percentage).hex();
    //     // if (i%2 === 0) {
    //     //
    //     // } else {
    //     //   extend = chroma(basecolour).darken(percentage).hex();
    //     // }
    //     extended.push(extend);
    //   }
    // }
    // return [...theme, ...extended];
    //
    // chroma.scale([...theme]).colors(5)

  }
};



// WEBPACK FOOTER //
// ./src/components/charts/highcharts-themes/helper.js